export const GenreTranslationJP = {
  Genre: {
    Title: 'ジャンル一覧',
    Headers: {
      title: 'ジャンル詳細',
      add: 'ジャンル詳細',
      Desc: '※モバイルオーダーは、 <br /> 　日本語以外の言語を選択し、その言語が未設定の場合、<br /> 　英語が表示されます。',
    },
    Filter: {
      name: '名称',
      delete_date: '削除データ',
      hide_del: '削除データ非表示',
      show_all_del: '削除データ含めて表示',
      show_del: '削除データのみ表示',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      search: '絞り込み',
      add_new: '追加',
      keep: '保存',
      preview: 'プレビュー',
      restore: '復元',
    },
    Table: {
      selection: '選択',
      genre_name: 'ジャンル名',
      remarks: '備考',
    },
    Form: {
      genre_name: 'ジャンル名',
      select_lunch: 'セレクトランチ',
      image: '画像',
      background: '背景',
      color: '色',
      change: '変更',
      display_name: '表示名',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      free_group_lunch: '自由组合午餐',
      chinese_traditional: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      remarks: '備考',
    },
    Validator: {
      name: 'Required name field',
      500: '500 error server',
      success: '成功',
      error: '失敗',
      delete_success: '削除しました',
      add_success: '保存しました',
      restore_success: '復元しました。',
    },
  },
  ModalSearch: {
    title: 'プレビュー',
    language: '言語：',
  },
};
